/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse {
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse
     */
    fieldHeader?: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse
     */
    fieldFooter?: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse
     */
    fieldImage?: Array<JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage>;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldHeader': !exists(json, 'field_header') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderFromJSON(json['field_header']),
        'fieldFooter': !exists(json, 'field_footer') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterFromJSON(json['field_footer']),
        'fieldImage': !exists(json, 'field_image') ? undefined : ((json['field_image'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageFromJSON)),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field_header': JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderToJSON(value.fieldHeader),
        'field_footer': JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterToJSON(value.fieldFooter),
        'field_image': value.fieldImage === undefined ? undefined : ((value.fieldImage as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageToJSON)),
    };
}

